import _groupBy from 'lodash/groupBy';


/*
 * takes an array of moment objects
 * outputs a formated string of dates grouped by year, eg.:
 * "Jan 3, Jan 4 2018, Feb 11, March 15 2019"
 */
export const renderCourseDates = (datesList) => {
    if (!datesList || datesList.length === 0) {
        return "-";
    }
    var groups = _groupBy(datesList, function (date) {
        return date.format('YYYY');
    });
    var years = Object.keys(groups);
    var strings = [];
    for (let i=0; i<years.length; i++) {
        var dateString = "";
        var year = years[i];
        var group = groups[year];
        for (let s=0; s<group.length; s++) {
            var date = group[s];
            dateString += date.format("D MMM");
            if (s < group.length - 1) {
                dateString += ", ";
            } else {
                dateString += " ";
            }
        }
        dateString += year;
        strings.push(dateString);
    }
    return strings.join(", ");
}

export const formatCreditCard = (value) => {
    if (value === '') { return ''; }
    let rawdata = value.replace(/\D/g,'');
    if (rawdata.length < 5) {
        return rawdata;
    }
    let formatted = '';
    let firstTwo = rawdata.substring(0,2);
    if (firstTwo === '34' || firstTwo === '37') {
        // amex
        rawdata = rawdata.substring(0,15);
        if (rawdata.length < 11) {
            formatted = rawdata.replace(/\b(\d{4})(\d{1,6})\b/, '$1 $2');
        } else {
            formatted = rawdata.replace(/\b(\d{4})(\d{6})(\d{1,5})\b/, '$1 $2 $3');
        }
    } else {
        // normal cc
        rawdata = rawdata.substring(0,16);
        let pieces = rawdata.match(/\d{1,4}/g);
        formatted = pieces ? pieces.join(' ') : '';
    }
    return formatted;
};

export const scrollToTop = () => {
    if (typeof window === 'object' && typeof window.scrollTo === 'function') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export const scrollToRef = (ref) => {
    if (typeof window === 'object' && typeof window.scrollTo === 'function') {
        window.scrollTo({top: ref.current.offsetTop, behavior: 'smooth'});
    }
}
